import React, { useState, useEffect } from 'react';
import { Search, Filter, UserPlus, Users, MoreVertical, Mail, Phone, Edit, Eye, Loader, Upload } from 'lucide-react';
import ExpandableSearchBar from '../components/ExpandableSearchBar';
import { employeesApi, departmentsApi, teamsApi, designationsApi } from '../services/api';
import { Dropdown, Menu } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import BulkEmployeeUploadModal from "../components/BulkEmployeeUploadModal"
function EmployeeManagement() {
  const { currentTheme } = useTheme();
  const isDark = currentTheme.textColor === '#FFFFFF' || currentTheme.color === '#0f172a';
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('employees');
  const [searchTerm, setSearchTerm] = useState('');
  const [showAddModal, setShowAddModal] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [openMenuId, setOpenMenuId] = useState(null);
  const [viewMode, setViewMode] = useState('grid');
  const [editingEmployeeId, setEditingEmployeeId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [isEditMode, setIsEditMode] = useState(false);
  const [showEmployeePopup, setShowEmployeePopup] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [employees, setEmployees] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [teams, setTeams] = useState([]);
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);
  const [teamModalState, setTeamModalState] = useState({
    isOpen: false,
    employee: null,
    newTeamId: '',
    isLoading: false
  });
  const tabs = [
    { key: 'employees', label: 'Employees list' },
    { key: 'department', label: 'Department' },
    { key: 'designation', label: 'Designation' },
    { key: 'teams', label: 'Teams' },
  ];

  const [formData, setFormData] = useState({
    employeeId: '',
    name: '',
    contactNumber: '',
    email: '',
    gender: 'MALE',
    addressStreet: '',
    landmark: '',
    pincode: '',
    city: '',
    district: '',
    state: '',
    departmentId: '',
    team: '',
    designationId: '',
    employeeCode: '',
    agentId: '',
    username: '',
    password: ''
  });
  const getMenuItems = (employee) => {
    const empId = employee.id || employee._id || employee.employeeId;
    return [
      {
        key: 'details',
        label: (
          <div
            className="flex items-center space-x-2 ">
            <svg width="17" height="11" viewBox="0 0 17 11" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M3.05225 1.55148C1.38269 2.66477 0.344462 4.17054 0 5.40971C0.344406 6.64895 1.38269 8.15478 3.05225 9.26794C6.15483 11.3366 10.5875 11.3366 13.6899 9.26794C15.3595 8.15465 16.3977 6.64813 16.7422 5.40971C16.3978 4.17047 15.3595 2.66464 13.6899 1.55148C10.5874 -0.517159 6.15465 -0.517159 3.05225 1.55148ZM10.0845 3.69653C11.031 4.64308 11.031 6.17729 10.0845 7.12382C8.56124 8.64703 5.94812 7.56215 5.94812 5.41057C5.94812 3.25749 8.56196 2.17335 10.0845 3.69653ZM8.37121 1.86824C11.5159 1.86824 13.101 5.68863 10.8753 7.91384C8.6495 10.1396 4.82966 8.55458 4.82966 5.40978C4.82966 3.45411 6.41549 1.86824 8.37121 1.86824Z" fill="#77B9A0" />
            </svg>

            <span>Details</span>
          </div>
        ),
        onClick: (e) => { e.domEvent.stopPropagation(); navigate(`/employees/${empId}`); }
      },
      {
        key: 'edit',
        label: (
          <div className="flex items-center space-x-2 ">
            <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3.13045 14.2213H11.3075C12.7577 14.2213 13.9379 13.143 13.9379 11.818V8.46048C13.9379 8.26246 13.7606 8.10043 13.5439 8.10043C13.3271 8.10043 13.1498 8.26246 13.1498 8.46048V11.818C13.1498 12.7451 12.3242 13.5012 11.3075 13.5012H3.13045C2.11374 13.5012 1.28815 12.7469 1.28815 11.818V4.34867C1.28815 3.42153 2.11374 2.66542 3.13045 2.66542H6.48993C6.70668 2.66542 6.88401 2.5034 6.88401 2.30537C6.88401 2.10734 6.70668 1.94531 6.48993 1.94531H3.13045C1.68025 1.94531 0.5 3.02367 0.5 4.34867V11.818C0.5 13.1448 1.68025 14.2213 3.13045 14.2213Z" fill="#77B9A0" stroke="#77B9A0" />
              <path d="M11.7891 2.01562L13.8796 3.95263L8.79157 8.53688L6.56991 8.40199L6.70098 6.59987L11.7891 2.01562Z" fill="#77B9A0" />
              <path d="M12.7839 1.11865C13.1966 0.746778 13.8577 0.747822 14.2605 1.12099L14.8926 1.70668C15.2953 2.07985 15.2872 2.68382 14.8744 3.0557L14.3497 3.5284L12.2592 1.59135L12.7839 1.11865Z" fill="#77B9A0" />
            </svg>

            <span>Edit</span>
          </div>
        ),
        onClick: (e) => { e.domEvent.stopPropagation(); handleEditEmployee(employee); }
      },
      {
        key: 'change-team',
        label: (
          <div className="flex items-center space-x-2 ">
            <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.41827 15.542C6.89909 15.5388 6.3754 15.4932 5.85494 15.4017C5.80321 15.9195 5.78644 16.45 5.80636 16.9939C4.29189 15.435 2.76442 13.8625 1.22281 12.2755L7.5185 10.5831C7.25589 11.0045 7.02169 11.4358 6.81703 11.8785C6.8518 11.8847 6.88723 11.8911 6.92227 11.8976C7.08555 11.9297 7.24891 11.9593 7.41236 11.9863C8.55749 12.1757 9.71415 12.2369 10.8334 12.1263C11.0443 12.1053 11.2533 12.0774 11.4602 12.0429C11.6673 12.0087 11.8728 11.9677 12.0757 11.9197C12.2931 11.8688 12.5064 11.81 12.7151 11.7426C13.3407 11.5407 13.9281 11.2652 14.4566 10.9067C14.6394 10.7845 14.8138 10.6525 14.9792 10.5108C15.1445 10.3693 15.3007 10.2174 15.4464 10.0554C15.5716 9.92878 15.6937 9.79943 15.8154 9.6696C15.7789 9.83108 15.7358 9.99084 15.6863 10.1482C15.6363 10.3051 15.5801 10.4604 15.518 10.6127C15.082 11.6702 14.3783 12.6117 13.4966 13.3935C13.3766 13.4981 13.2542 13.6002 13.1278 13.699C12.7496 13.9945 12.3426 14.2616 11.912 14.496C11.7269 14.5946 11.538 14.6867 11.3444 14.7722C10.377 15.1997 9.29934 15.4584 8.16845 15.5179C7.91974 15.5355 7.66997 15.544 7.41827 15.542Z" fill="#77B9A0" />
              <path d="M7.74571 3.39834C8.26182 3.34191 8.78729 3.32715 9.31481 3.3583C9.30676 2.838 9.26251 2.30902 9.18029 1.77101C10.8637 3.14573 12.5616 4.53249 14.2752 5.93211L8.21537 8.33595C8.42787 7.88724 8.61102 7.4319 8.76351 6.96864C8.72826 6.96649 8.69233 6.96415 8.65678 6.96176C8.49089 6.94856 8.32521 6.93793 8.15974 6.92987C7.00043 6.87316 5.8444 6.94518 4.74523 7.18348C4.53818 7.22859 4.33376 7.28024 4.13219 7.33833C3.93035 7.39603 3.73094 7.46037 3.53489 7.53129C3.32471 7.6069 3.11959 7.68972 2.91999 7.78067C2.32171 8.05303 1.7698 8.39417 1.28594 8.81092C1.11842 8.95332 0.960341 9.10448 0.812307 9.26424C0.664353 9.42371 0.526585 9.59261 0.400491 9.77026C0.290621 9.9104 0.184178 10.0529 0.0781683 10.1959C0.0958701 10.0312 0.120362 9.86759 0.151445 9.70562C0.183174 9.54399 0.221138 9.38332 0.265356 9.22485C0.57712 8.12425 1.16801 7.10828 1.95421 6.23041C2.06134 6.11271 2.17121 5.9972 2.28546 5.88463C2.62727 5.5476 3.00092 5.23561 3.40175 4.95332C3.57431 4.83412 3.75134 4.72087 3.93391 4.61372C4.84583 4.07803 5.88667 3.69735 7.00325 3.50845C7.24829 3.46233 7.49544 3.42527 7.74571 3.39834Z" fill="#77B9A0" />
            </svg>

            <span>Change Team</span>
          </div>
        ),
        onClick: (e) => { e.domEvent.stopPropagation(); handleChangeTeamClick(employee); }
      },
      {
        type: 'divider'
      },
    ];
  };
  const handleChangeTeamClick = (employeeObj) => {
    console.log('Change team:', employeeObj);
    setTeamModalState({
      isOpen: true,
      employee: employeeObj,
      newTeamId: '',
      isLoading: false
    });
  };
  const handleBulkUploadSuccess = (result) => {
    console.log('Bulk upload completed:', result);
    showToast(`Successfully uploaded ${result.successCount} employees`);
    fetchEmployees();
  };
  const handleEditEmployee = async (employeeObj) => {
    const empId = employeeObj.id || employeeObj._id || employeeObj.employeeId;
    navigate(`/employees/edit/${empId}`);
  };
  const handleToggleStatus = async (employee, newStatus) => {
    try {
      const empId = employee.id || employee._id || employee.employeeId;
      await employeesApi.updateEmployee(empId, { active: newStatus });
      showToast(`Employee status updated to ${newStatus ? 'Active' : 'Inactive'}`);
      fetchEmployees();
    } catch (error) {
      console.error('Error updating status:', error);
      showToast('Failed to update employee status');
    }
  };
  // Updated handleAddEmployee to handle both add and edit
  const handleSaveEmployee = async () => {
    // Mark all fields as touched
    const allTouched = {};
    Object.keys(formData).forEach(key => {
      allTouched[key] = true;
    });
    setTouched(allTouched);

    // Validate form
    if (!validateForm()) {
      showToast('Please fix all errors before submitting');
      return;
    }

    try {
      setLoading(true);

      const employeePayload = {
        employeeId: formData.employeeId,
        name: formData.name,
        email: formData.email,
        contactNumber: formData.contactNumber,
        gender: formData.gender,
        addressStreet: formData.addressStreet,
        landmark: formData.landmark,
        pincode: formData.pincode,
        city: formData.city,
        district: formData.district,
        state: formData.state,
        departmentId: parseInt(formData.departmentId),
        designationId: parseInt(formData.designationId),
        teamId: parseInt(formData.team),
        employeeCode: formData.employeeCode,
        agentId: formData.agentId,
        password: formData.password
      };

      if (isEditMode) {
        // Update existing employee
        console.log("editingEmployeeId", editingEmployeeId)
        await employeesApi.updateEmployee(editingEmployeeId, employeePayload);
        showToast('Employee updated successfully!');
      } else {
        // Create new employee
        await employeesApi.createEmployee(employeePayload);
        console.log("employeePayload", employeePayload)
        showToast('Employee added successfully!');
      }

      setShowAddModal(false);
      resetForm();
      fetchEmployees();
    } catch (error) {
      console.error('Error saving employee:', error);
      showToast(isEditMode ? 'Failed to update employee' : 'Failed to add employee');
    } finally {
      setLoading(false);
    }
  };
  // Validation rules
  const validateField = (name, value) => {
    let error = '';

    switch (name) {
      case 'employeeId':
        if (!value || value.trim() === '') {
          error = 'Employee ID is required';
        }
        break;

      case 'name':
        if (!value || value.trim() === '') {
          error = 'Employee name is required';
        } else if (value.length < 3) {
          error = 'Name must be at least 3 characters';
        } else if (!/^[a-zA-Z\s]+$/.test(value)) {
          error = 'Name should only contain letters';
        }
        break;

      case 'contactNumber':
        if (!value || value.trim() === '') {
          error = 'Contact number is required';
        } else if (!/^[0-9]{10}$/.test(value)) {
          error = 'Contact number must be 10 digits';
        }
        break;

      case 'email':
        if (!value || value.trim() === '') {
          error = 'Email is required';
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          error = 'Please enter a valid email';
        }
        break;

      case 'addressStreet':
        if (!value || value.trim() === '') {
          error = 'Address is required';
        }
        break;

      case 'pincode':
        if (!value || value.trim() === '') {
          error = 'Pincode is required';
        } else if (!/^[0-9]{6}$/.test(value)) {
          error = 'Pincode must be 6 digits';
        }
        break;

      case 'city':
        if (!value || value.trim() === '') {
          error = 'City is required';
        }
        break;

      case 'district':
        if (!value || value.trim() === '') {
          error = 'District is required';
        }
        break;

      case 'state':
        if (!value || value.trim() === '') {
          error = 'State is required';
        }
        break;

      case 'departmentId':
        if (!value) {
          error = 'Department is required';
        }
        break;

      case 'team':
        if (!value) {
          error = 'Team is required';
        }
        break;

      case 'designationId':
        if (!value) {
          error = 'Designation is required';
        }
        break;

      case 'employeeCode':
        if (!value || value.trim() === '') {
          error = 'Employee code is required';
        }
        break;

      case 'agentId':
        if (!value || value.trim() === '') {
          error = 'Agent ID is required';
        }
        break;
      case 'Password':
        if (!value || value.trim() === '') {
          error = 'Password is required';
        }
        break;

      default:
        break;
    }

    return error;
  };

  const validateForm = () => {
    const newErrors = {};

    // Required fields
    const requiredFields = [
      'employeeId',
      'name',
      'contactNumber',
      'email',
      'addressStreet',
      'pincode',
      'city',
      'district',
      'state',
      'departmentId',
      'team',
      'designationId',
      'employeeCode',
      'agentId',
      'password'
    ];

    requiredFields.forEach(field => {
      const error = validateField(field, formData[field]);
      if (error) {
        newErrors[field] = error;
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (name, value) => {
    setFormData({
      ...formData,
      [name]: value
    });

    // Validate field on change if it has been touched
    if (touched[name]) {
      const error = validateField(name, value);
      setErrors({
        ...errors,
        [name]: error
      });
    }
  };

  const handleBlur = (name) => {
    setTouched({
      ...touched,
      [name]: true
    });

    const error = validateField(name, formData[name]);
    setErrors({
      ...errors,
      [name]: error
    });
  };

  const handleAddEmployee = async () => {
    // Mark all fields as touched
    const allTouched = {};
    Object.keys(formData).forEach(key => {
      allTouched[key] = true;
    });
    setTouched(allTouched);

    // Validate form
    if (!validateForm()) {
      showToast('Please fix all errors before submitting');
      return;
    }

    try {
      setLoading(true);

      const employeePayload = {
        employeeId: formData.employeeId,
        name: formData.name,
        email: formData.email,
        contactNumber: formData.contactNumber,
        gender: formData.gender,
        addressStreet: formData.addressStreet,
        landmark: formData.landmark,
        pincode: formData.pincode,
        city: formData.city,
        district: formData.district,
        state: formData.state,
        departmentId: parseInt(formData.departmentId),
        designationId: parseInt(formData.designationId),
        teamId: parseInt(formData.team),
        employeeCode: formData.employeeCode,
        agentId: formData.agentId,
        password: formData.password
      };

      await employeesApi.createEmployee(employeePayload);
      showToast('Employee added successfully!');
      setShowAddModal(false);
      resetForm();
      fetchEmployees();
    } catch (error) {
      console.error('Error adding employee:', error);
      showToast('Failed to add employee');
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setFormData({
      employeeId: '',
      name: '',
      contactNumber: '',
      email: '',
      gender: 'MALE',
      addressStreet: '',
      landmark: '',
      pincode: '',
      city: '',
      district: '',
      state: '',
      departmentId: '',
      team: '',
      designationId: '',
      employeeCode: '',
      agentId: '',
      username: '',
      password: ''
    });
    setErrors({});
    setTouched({});
    setIsEditMode(false);
    setEditingEmployeeId(null);
  };

  // ... rest of your code

  // Update the Add Employee Modal with error messages

  const [departmentFormData, setDepartmentFormData] = useState({
    name: '',
    description: ''
  });

  const [designationFormData, setDesignationFormData] = useState({
    name: '',
    description: ''
  });

  const [teamFormData, setTeamFormData] = useState({
    name: '',
    description: '',
    isActive: true
  });

  // Fetch all data on component mount
  useEffect(() => {
    fetchAllData();
  }, [activeTab]);

  const fetchAllData = async () => {
    setLoading(true);
    try {
      if (activeTab === 'employees') {
        await fetchEmployees();
      } else if (activeTab === 'department') {
        await fetchDepartments();
      } else if (activeTab === 'designation') {
        await fetchDesignations();
      } else if (activeTab === 'teams') {
        await fetchTeams();
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      showToast('Failed to load data');
    } finally {
      setLoading(false);
    }
  };

  const fetchEmployees = async () => {
    try {
      const data = await employeesApi.getAllEmployees();
      console.log("data", data)
      const mappedData = Array.isArray(data) ? data.map(emp => ({
        ...emp,
        isActive: emp.isActive !== undefined ? emp.isActive : (emp.status !== undefined ? emp.status : (emp.active !== undefined ? emp.active : true))
      })) : [];
      setEmployees(mappedData);
    } catch (error) {
      console.error('Error fetching employees:', error);
    }
  };

  const fetchDepartments = async () => {
    try {
      const data = await departmentsApi.getAllDepartments();
      setDepartments(data);
    } catch (error) {
      console.error('Error fetching departments:', error);
    }
  };

  const fetchDesignations = async () => {
    try {
      const data = await designationsApi.getAllDesignations();
      setDesignations(data);
    } catch (error) {
      console.error('Error fetching designations:', error);
    }
  };

  const fetchTeams = async () => {
    try {
      const data = await teamsApi.getAllTeams();
      const mappedData = Array.isArray(data) ? data.map(team => ({
        ...team,
        isActive: team.isActive !== undefined ? team.isActive : (team.status !== undefined ? (team.status === 'ACTIVE' || team.status === true) : (team.active !== undefined ? team.active : true))
      })) : [];
      setTeams(mappedData);
    } catch (error) {
      console.error('Error fetching teams:', error);
    }
  };

  const handleToggleTeamStatus = async (team) => {
    const currentActive = team.isActive !== undefined ? team.isActive : (team.status !== undefined ? (team.status === 'ACTIVE' || team.status === true) : (team.active !== undefined ? team.active : true));
    const newActive = !currentActive;

    // Optimistic UI update
    setTeams(prev => prev.map(t => (t.id === team.id || t._id === team.id) ? {
      ...t,
      isActive: newActive,
      active: newActive,
      status: newActive ? 'ACTIVE' : 'INACTIVE'
    } : t));

    try {
      let success = false;
      const teamId = team.id || team._id;
      if (teamsApi.updateTeamStatus) {
        try {
          await teamsApi.updateTeamStatus(teamId, newActive);
          success = true;
        } catch (patchErr) {
          console.warn('updateTeamStatus PATCH failed, attempting updateTeam PUT:', patchErr);
        }
      }
      if (!success) {
        await teamsApi.updateTeam(teamId, {
          ...team,
          isActive: newActive,
          active: newActive,
          status: newActive ? 'ACTIVE' : 'INACTIVE'
        });
      }
      showToast(`Team "${team.name}" is now ${newActive ? 'Active' : 'Inactive'}!`);
    } catch (error) {
      console.error('Error updating team status:', error);
      showToast('Failed to update team status');
      fetchTeams(); // Rollback
    }
  };

  // Search employees
  const handleSearch = async (term) => {
    setSearchTerm(term);
    if (activeTab === 'employees' && term.trim()) {
      try {
        const data = await employeesApi.searchEmployees(term);
        const mappedData = Array.isArray(data) ? data.map(emp => ({
          ...emp,
          isActive: emp.isActive !== undefined ? emp.isActive : (emp.status !== undefined ? emp.status : (emp.active !== undefined ? emp.active : true))
        })) : [];
        setEmployees(mappedData);
      } catch (error) {
        console.error('Error searching employees:', error);
      }
    } else if (activeTab === 'employees' && !term.trim()) {
      fetchEmployees();
    }
  };

  const showToast = (message) => {
    setToastMessage(message);
    setShowSuccessToast(true);
    setTimeout(() => setShowSuccessToast(false), 3000);
  };



  const handleEditCard = (item, type) => {
    setIsEditMode(true);
    setEditingEmployeeId(item.id); // Reusing this for ID tracking
    if (type === 'department') {
      setDepartmentFormData({ name: item.name, description: item.description || '' });
    } else if (type === 'designation') {
      setDesignationFormData({ name: item.name, description: item.description || '' });
    } else if (type === 'team') {
      const isTeamActive = item.isActive !== undefined ? item.isActive : (item.status !== undefined ? (item.status === 'ACTIVE' || item.status === true) : (item.active !== undefined ? item.active : true));
      setTeamFormData({
        name: item.name,
        description: item.description || '',
        isActive: isTeamActive
      });
    }
    setShowAddModal(true);
  };

  const handleAddDepartment = async () => {
    try {
      setLoading(true);
      if (isEditMode) {
        await departmentsApi.updateDepartment(editingEmployeeId, departmentFormData);
        showToast('Department updated successfully!');
      } else {
        await departmentsApi.createDepartment(departmentFormData);
        showToast('Department added successfully!');
      }
      setShowAddModal(false);
      setIsEditMode(false);
      setEditingEmployeeId(null);
      setDepartmentFormData({ name: '', description: '' });
      fetchDepartments();
    } catch (error) {
      console.error('Error saving department:', error);
      showToast(`Failed to ${isEditMode ? 'update' : 'add'} department`);
    } finally {
      setLoading(false);
    }
  };

  const handleAddDesignation = async () => {
    try {
      setLoading(true);
      if (isEditMode) {
        await designationsApi.updateDesignation(editingEmployeeId, designationFormData);
        showToast('Designation updated successfully!');
      } else {
        await designationsApi.createDesignation(designationFormData);
        showToast('Designation added successfully!');
      }
      setShowAddModal(false);
      setIsEditMode(false);
      setEditingEmployeeId(null);
      setDesignationFormData({ name: '', description: '' });
      fetchDesignations();
    } catch (error) {
      console.error('Error saving designation:', error);
      showToast(`Failed to ${isEditMode ? 'update' : 'add'} designation`);
    } finally {
      setLoading(false);
    }
  };

  const handleClosePopup = () => {
    setShowEmployeePopup(false);
    setSelectedEmployee(null);
  };

  const handleAddTeam = async () => {
    try {
      setLoading(true);
      const payload = {
        name: teamFormData.name,
        description: teamFormData.description,
        isActive: teamFormData.isActive !== undefined ? teamFormData.isActive : true,
        active: teamFormData.isActive !== undefined ? teamFormData.isActive : true,
        status: teamFormData.isActive ? 'ACTIVE' : 'INACTIVE'
      };
      if (isEditMode) {
        await teamsApi.updateTeam(editingEmployeeId, payload);
        showToast('Team updated successfully!');
      } else {
        await teamsApi.createTeam(payload);
        showToast('Team added successfully!');
      }
      setShowAddModal(false);
      setIsEditMode(false);
      setEditingEmployeeId(null);
      setTeamFormData({ name: '', description: '', isActive: true });
      fetchTeams();
    } catch (error) {
      console.error('Error saving team:', error);
      showToast(`Failed to ${isEditMode ? 'update' : 'add'} team`);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteEmployee = async (id) => {
    if (window.confirm('Are you sure you want to delete this employee?')) {
      try {
        await employeesApi.deleteEmployee(id);
        showToast('Employee deleted successfully!');
        fetchEmployees();
      } catch (error) {
        console.error('Error deleting employee:', error);
        showToast('Failed to delete employee');
      }
    }
  };

  const handleChangeTeam = async (employeeId, newTeamId) => {
    try {
      await employeesApi.changeEmployeeTeam(employeeId, {
        newTeamId: newTeamId,
        reason: 'Team reassignment'
      });
      showToast('Employee team changed successfully!');
      fetchEmployees();
    } catch (error) {
      console.error('Error changing team:', error);
      showToast('Failed to change team');
    }
  };



  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = () => setOpenMenuId(null);
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Fetch departments and teams for dropdowns
  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const [depts, desigs, tms] = await Promise.all([
          departmentsApi.getAllDepartments(),
          designationsApi.getAllDesignations(),
          teamsApi.getAllTeams()
        ]);
        setDepartments(depts);
        setDesignations(desigs);
        setTeams(tms);
      } catch (error) {
        console.error('Error fetching dropdown data:', error);
      }
    };
    fetchDropdownData();
  }, []);

  const getAvatarColor = (name) => {
    const colors = [
      'bg-blue-500', 'bg-purple-500', 'bg-pink-500',
      'bg-indigo-500', 'bg-green-500', 'bg-red-500', 'bg-orange-500'
    ];
    const index = name.charCodeAt(0) % colors.length;
    return colors[index];
  };

  const renderEmployeeCard = (employee) => (
    <div
      key={employee.id}
      onClick={() => navigate(`/employees/${employee.id || employee._id || employee.employeeId}`)}
      className="bg-white rounded-lg shadow-sm hover:shadow-lg transition-shadow relative overflow-hidden w-full h-full min-h-[210px] cursor-pointer flex flex-col"
    >
      {/* Header with ID and Menu */}
      <div className="px-4 py-3 flex items-center justify-between rounded-t-lg flex-shrink-0" style={{ backgroundColor: currentTheme.color }}>
        <div className="text-sm text-white font-medium">Emp ID: {employee.employeeId}</div>
        <div className="relative">
          <Dropdown
            menu={{ items: getMenuItems(employee) }}
            trigger={['click']}
            placement="bottomRight"
          >
            <button
              onClick={(e) => e.stopPropagation()}
              className="p-2 hover:bg-gray-100/10 rounded transition-colors"
            >
              <MoreVertical className="w-5 h-5 text-white" />
            </button>
          </Dropdown>
        </div>
      </div>

      {/* Card Content with light green background */}
      <div className="bg-white flex-1 flex flex-col">
        {/* Avatar and Name Section */}
        <div className="flex items-center space-x-3 py-3 px-4">
          <div className={`w-[35px] h-[35px] rounded-lg flex items-center justify-center text-white font-bold text-lg flex-shrink-0`} style={{ backgroundColor: currentTheme.color }}>
            {employee.name.charAt(0).toUpperCase()}
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="font-semibold text-gray-900 text-sm truncate">{employee.name}</h3>
            <p className="text-xs text-gray-600 truncate">{employee.designationName || 'N/A'}</p>
          </div>
        </div>

        <div className='p-3 flex-1 flex flex-col justify-end'>
          <div className='p-3 rounded-[10px] w-full' style={{ backgroundColor: currentTheme.color + '1A' }}>
            {/* Department */}
            <div className="mb-2">
              <p className="text-[10px] text-gray-600 mb-0.5">Department</p>
              <p className="text-sm font-semibold text-gray-900 truncate">{employee.departmentName || 'N/A'}</p>
            </div>

            {/* Contact Info */}
            <div className="space-y-2">
              <div className="flex items-center space-x-2">
                <svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg" className="flex-shrink-0">
                  <path fillRule="evenodd" clipRule="evenodd" d="M2.61355 0C1.17012 0 0 1.17012 0 2.61355V7.71812C0 9.16154 1.17012 10.3317 2.61354 10.3317H9.78446C11.2279 10.3317 12.398 9.16154 12.398 7.71812V2.61355C12.398 1.17012 11.2279 0 9.78446 0H2.61355ZM2.56257 3.17714C2.71186 2.95341 3.01425 2.89305 3.23799 3.04234L6.15468 4.98845L9.07138 3.04234C9.29512 2.89305 9.59751 2.95341 9.7468 3.17714C9.89608 3.40088 9.83573 3.70328 9.61199 3.85257L6.52813 5.91022C6.41387 5.98646 6.2791 6.00802 6.15468 5.98107C6.03027 6.00802 5.89549 5.98646 5.78124 5.91022L2.69738 3.85257C2.47364 3.70328 2.41328 3.40088 2.56257 3.17714Z" fill={currentTheme.color} />
                </svg>
                <span className="text-xs truncate">{employee.email || 'N/A'}</span>
              </div>
              <div className="flex items-center space-x-2">
                <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg" className="flex-shrink-0">
                  <path d="M5.93395 12.022C6.59854 12.5256 7.36951 12.811 8.15058 12.8787C9.23539 12.9727 10.3476 12.6494 11.2342 11.9043C11.5643 11.6268 11.7566 11.2238 11.7595 10.7869C11.7703 10.3594 11.5879 9.94134 11.2626 9.65959L10.0443 8.58344C9.5004 8.09912 8.66199 8.08766 8.1056 8.55534L7.90755 8.72179C7.32209 9.22193 6.46407 9.23498 5.88323 8.7737C4.94158 8.0363 4.19651 7.14985 3.65363 6.14971C3.29912 5.49817 3.47547 4.67405 4.06018 4.18264L4.27709 4.00033C4.83352 3.53265 4.96645 2.70477 4.58291 2.08571L3.73239 0.700436C3.50211 0.330729 3.13036 0.0799324 2.70738 0.0170315C2.28515 -0.0545342 1.84635 0.0648271 1.51629 0.342242C0.629805 1.08733 0.11128 2.12663 0.0165165 3.22013C-0.0504184 3.99251 0.0981052 4.80108 0.479796 5.54239C1.78873 8.09535 3.62844 10.2747 5.93395 12.022Z" fill={currentTheme.color} />
                </svg>
                <span className="text-xs truncate">{employee.contactNumber || 'N/A'}</span>
              </div>
            </div>

            {/* Status Switch */}
            <div className="mt-3 pt-2.5 border-t border-gray-200/50 flex items-center justify-between">
              <span className="text-[10px] font-semibold text-gray-500">Status</span>
              <div className="flex items-center space-x-2">
                <span className={`text-xs font-bold ${employee.isActive ? 'text-green-600' : 'text-red-500'}`}>
                  {employee.isActive ? 'Active' : 'Inactive'}
                </span>
                <Toggle
                  checked={employee.isActive}
                  onChange={(checked) => handleToggleStatus(employee, checked)}
                  color={currentTheme.color}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderEmployeeList = (employee) => (
    <div key={employee.id} className="bg-white border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4 flex-1 overflow-hidden">
          <div className={`w-12 h-12 ${getAvatarColor(employee.name)} rounded-full flex items-center justify-center text-white font-bold text-lg flex-shrink-0`}>
            {employee.name.charAt(0).toUpperCase()}
          </div>
          <div className="flex-1 grid grid-cols-2 md:grid-cols-5 gap-4">
            <div className="min-w-0">
              <p className="text-xs text-gray-500 mb-1">Employee ID</p>
              <p className="font-semibold text-gray-900 truncate">{employee.employeeId}</p>
            </div>
            <div className="min-w-0">
              <p className="text-xs text-gray-500 mb-1">Name</p>
              <p className="font-semibold text-gray-900 truncate">{employee.name}</p>
            </div>
            <div className="hidden md:block min-w-0">
              <p className="text-xs text-gray-500 mb-1">Role</p>
              <p className="text-sm text-gray-700 truncate">{employee.designationName || 'N/A'}</p>
            </div>
            <div className="hidden md:block min-w-0">
              <p className="text-xs text-gray-500 mb-1">Department</p>
              <p className="text-sm text-gray-700 truncate">{employee.departmentName || 'N/A'}</p>
            </div>
            <div className="hidden md:block min-w-0">
              <p className="text-xs text-gray-500 mb-1">Status</p>
              <div className="flex items-center space-x-2">
                <span className={`text-xs font-bold ${employee.isActive ? 'text-green-600' : 'text-red-500'}`}>
                  {employee.isActive ? 'Active' : 'Inactive'}
                </span>
                <Toggle
                  checked={employee.isActive}
                  onChange={(checked) => handleToggleStatus(employee, checked)}
                  color={currentTheme.color}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="relative ml-4">
          <button
            onClick={() => setOpenMenuId(openMenuId === employee.id ? null : employee.id)}
            className="p-2 hover:bg-gray-100 rounded transition-colors"
          >
            <MoreVertical className="w-5 h-5 text-gray-600" />
          </button>
          {openMenuId === employee.id && (
            <div className="absolute right-0 top-full mt-1 bg-white rounded-lg shadow-lg border border-gray-200 py-2 w-40 z-20">
              <button
                onClick={(e) => { e.stopPropagation(); navigate(`/employees/${employee.id || employee._id || employee.employeeId}`); }}
                className="w-full px-4 py-2 text-left text-sm hover:bg-gray-50 flex items-center space-x-2"
              >
                <Eye className="w-4 h-4" />
                <span>Details</span>
              </button>
              <button
                onClick={(e) => { e.stopPropagation(); handleEditEmployee(employee); setOpenMenuId(null); }}
                className="w-full px-4 py-2 text-left text-sm hover:bg-gray-50 flex items-center space-x-2"
              >
                <Edit className="w-4 h-4" />
                <span>Edit</span>
              </button>
              <button
                onClick={(e) => { e.stopPropagation(); handleChangeTeamClick(employee); setOpenMenuId(null); }}
                className="w-full px-4 py-2 text-left text-sm hover:bg-gray-50 flex items-center space-x-2"
              >
                <Users className="w-4 h-4" />
                <span>Change Team</span>
              </button>
              <button
                onClick={(e) => { e.stopPropagation(); handleDeleteEmployee(employee.id); setOpenMenuId(null); }}
                className="w-full px-4 py-2 text-left text-sm hover:bg-gray-50 flex items-center space-x-2 text-red-600"
              >
                <span>Delete</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );

  const renderCard = (item, type) => {
    const isTeam = type === 'team';
    const isTeamActive = isTeam ? (item.isActive !== undefined ? item.isActive : (item.status !== undefined ? (item.status === 'ACTIVE' || item.status === true) : (item.active !== undefined ? item.active : true))) : true;

    return (
      <div
        key={item.id}
        className={`border rounded-xl p-4 transition-all duration-200 h-full flex flex-col justify-between ${
          isTeam && !isTeamActive
            ? (isDark ? 'bg-[#1e293b]/50 border-gray-700/60 opacity-75' : 'bg-gray-50/80 border-gray-200 opacity-80')
            : (isDark ? 'bg-[#1e293b] border-white/10 hover:shadow-lg' : 'bg-white border-gray-200 hover:shadow-md')
        }`}
      >
        <div>
          <div className="flex items-start justify-between mb-3">
            <div className="min-w-0 flex-1 mr-2">
              <div className="flex items-center gap-2 flex-wrap">
                <h3 className={`font-semibold text-lg truncate ${isDark ? 'text-white' : 'text-gray-900'} ${isTeam && !isTeamActive ? 'line-through opacity-70' : ''}`}>
                  {item.name}
                </h3>
                {isTeam && (
                  <span
                    className={`text-[11px] font-semibold px-2 py-0.5 rounded-full inline-flex items-center gap-1 ${
                      isTeamActive
                        ? 'bg-emerald-50 text-emerald-700 border border-emerald-200'
                        : 'bg-red-50 text-red-600 border border-red-200'
                    }`}
                  >
                    <span className={`w-1.5 h-1.5 rounded-full ${isTeamActive ? 'bg-emerald-500' : 'bg-red-400'}`}></span>
                    {isTeamActive ? 'Active' : 'Inactive'}
                  </span>
                )}
              </div>
              <p className={`text-sm mt-0.5 ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
                {item.memberCount || item.members || 0} Members
              </p>
            </div>
            <button
              onClick={() => handleEditCard(item, type)}
              className={`p-1.5 rounded-lg transition-colors flex-shrink-0 ${isDark ? 'hover:bg-white/10 text-gray-400' : 'hover:bg-gray-100 text-gray-600'}`}
              title="Edit"
            >
              <Edit className="w-4 h-4" style={{ color: currentTheme.color }} />
            </button>
          </div>
        </div>

        <div className={`pt-3 border-t flex items-center justify-between mt-2 ${isDark ? 'border-white/10' : 'border-gray-100'}`}>
          <p className={`text-xs ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
            Added on: <span className={`font-medium ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>{item.createdAt ? new Date(item.createdAt).toLocaleDateString() : 'N/A'}</span>
          </p>
          {isTeam ? (
            <div className="flex items-center gap-2" title={isTeamActive ? 'Click to Inactivate Team' : 'Click to Activate Team'}>
              <span className={`text-xs font-medium ${isTeamActive ? 'text-emerald-600' : 'text-gray-400'}`}>
                {isTeamActive ? 'Active' : 'Inactive'}
              </span>
              <Toggle
                checked={isTeamActive}
                onChange={() => handleToggleTeamStatus(item)}
                color={currentTheme.color}
              />
            </div>
          ) : (
            <div className="w-3 h-3 rounded-full flex-shrink-0" style={{ backgroundColor: currentTheme.color }}></div>
          )}
        </div>
      </div>
    );
  };

  const TeamChangeModal = () => {
    // Add local state for reason inside the modal
    const [reason, setReason] = useState('');

    if (!teamModalState.isOpen) return null;

    const handleSubmit = async () => {
      if (!teamModalState.newTeamId) {
        showToast('Please select a team');
        return;
      }
      setTeamModalState(prev => ({ ...prev, isLoading: true }));
      try {
        const targetEmpId = teamModalState.employee.id || teamModalState.employee._id || teamModalState.employee.employeeId;
        await employeesApi.changeEmployeeTeam(targetEmpId, {
          newTeamId: parseInt(teamModalState.newTeamId),
          reason: reason || 'Team reassignment'
        });
        await fetchEmployees();
        showToast('Team changed successfully!');
        setTeamModalState({ isOpen: false, employee: null, newTeamId: '', isLoading: false });
        setReason('');
      } catch (err) {
        console.error('Error changing team:', err);
        showToast('Failed to change team');
        setTeamModalState(prev => ({ ...prev, isLoading: false }));
      }
    };

    return (
      <div className="fixed inset-0 bg-black/60 flex items-start pt-20 justify-center z-[9999] backdrop-blur-sm transition-all duration-300">
        <div className="bg-white rounded-2xl w-full max-w-sm mx-4 shadow-xl overflow-hidden pb-4">
          {/* Header */}
          <div className="px-6 py-4 flex items-center justify-between" style={{ backgroundColor: '#C8E6C9' }}>
            <h3 className="text-lg font-medium text-[#1A3B31]">Change Team</h3>
            <button disabled={teamModalState.isLoading} onClick={() => setTeamModalState({ ...teamModalState, isOpen: false })} className="text-[#1A3B31] hover:opacity-75 transition-colors text-xl">
              ✕
            </button>
          </div>
          {/* Body */}
          <div className="p-6 space-y-5">
            {/* Current Team */}
            <div>
              <label className="block text-xs font-semibold text-[#1A3B31] mb-1.5 opacity-80">Current Team</label>
              <div className="w-2/3 px-3 py-2.5 bg-[#F0F2F1] rounded-lg text-sm font-medium text-gray-800">
                {teamModalState.employee?.team?.name || teamModalState.employee?.teamName || (typeof teamModalState.employee?.team === 'string' ? teamModalState.employee?.team : null) || 'No Team Assigned'}
              </div>
            </div>

            {/* New Team */}
            <div>
              <label className="block text-xs font-semibold text-[#1A3B31] mb-1.5 opacity-80">New Team</label>
              <select value={teamModalState.newTeamId} onChange={e => setTeamModalState({ ...teamModalState, newTeamId: e.target.value })} className="w-full px-3 py-2.5 border border-gray-300 rounded-lg text-sm text-gray-800 bg-white focus:outline-none focus:ring-1 focus:ring-teal-500 appearance-none bg-no-repeat" style={{ backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%234ca182' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e")`, backgroundPosition: 'right 0.5rem center', backgroundSize: '1.5em 1.5em' }}>
                <option value="">Select a team</option>
                {teams.map(team => (
                  <option key={team.id} value={team.id}>{team.name}</option>
                ))}
              </select>
            </div>

            {/* Reason */}
            <div>
              <label className="block text-xs font-semibold text-[#1A3B31] mb-1.5 opacity-80">Reason</label>
              <textarea
                value={reason}
                onChange={e => setReason(e.target.value)}
                className="w-full px-3 py-3 bg-[#EEF5F2] border-none rounded-lg text-sm text-gray-800 placeholder-[#1A3B31] placeholder-opacity-70 focus:outline-none focus:ring-1 focus:ring-teal-500 resize-none h-20 leading-relaxed"
                placeholder="Moving people between teams spreads best practices, new ideas, and diverse perspective."
              ></textarea>
            </div>

            {/* Action */}
            <div className="flex justify-end pt-2">
              <button disabled={teamModalState.isLoading} onClick={handleSubmit} className="px-6 py-2 text-white font-medium hover:opacity-90 rounded-xl shadow-sm tracking-wide" style={{ backgroundColor: '#77B899' }}>
                {teamModalState.isLoading ? 'Processing...' : 'Save'}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={`space-y-6 min-h-screen -mx-8 px-8 pb-8 transition-colors duration-300 ${isDark ? 'bg-[#0f172a]' : ''}`}>
      <TeamChangeModal />
      {/* Success Toast */}
      {showSuccessToast && (
        <div className="fixed top-20 left-1/2 transform -translate-x-1/2 border-2 rounded-lg px-6 py-3 flex items-center space-x-3 shadow-lg z-50 animate-fade-in" style={{ backgroundColor: currentTheme.color + '1A', borderColor: currentTheme.color + '33' }}>
          <span className="font-medium" style={{ color: currentTheme.color }}>{toastMessage}</span>
          <button onClick={() => setShowSuccessToast(false)} className="hover:opacity-80" style={{ color: currentTheme.color }}>
            ✕
          </button>
        </div>
      )}

      {/* Header */}
      <div>
        <h2 className={`text-2xl font-bold ${isDark ? 'text-white' : 'text-gray-800'}`}>
          Employee <span className={`${isDark ? 'text-gray-500' : 'text-gray-400'}`}>({employees.length})</span>
        </h2>
      </div>

      {/* Tabs */}
      <div className={`border-b overflow-x-auto transition-colors ${isDark ? 'border-white/10' : 'border-gray-200'}`}>
        <div className="flex gap-8 min-w-max">
          {tabs.map((t) => (
            <button
              key={t.key}
              type="button"
              onClick={() => setActiveTab(t.key)}
              className={`pb-3 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${activeTab === t.key
                ? ''
                : 'border-transparent text-gray-500 hover:text-gray-700'
                }`}
              style={{
                color: activeTab === t.key ? currentTheme.color : undefined,
                borderColor: activeTab === t.key ? currentTheme.color : undefined
              }}
            >
              {t.label}
            </button>
          ))}
        </div>
      </div>

      {/* Search and Actions */}
      <div className="flex flex-col md:flex-row items-stretch md:items-center justify-between gap-4">
        <div className="flex items-center space-x-3 flex-1">
          <ExpandableSearchBar
            searchTerm={searchTerm}
            onSearchChange={handleSearch}
            placeholder="Search by employee name or employee ID"
          />
          <button className="p-3 border-2 border-gray-200 rounded-lg hover:bg-gray-50 transition-colors flex-shrink-0">
            <Filter className="w-5 h-5 text-gray-600" />
          </button>
        </div>

        <div className="flex items-center space-x-3 justify-end">
          {activeTab === 'employees' && (
            <>
              <BulkEmployeeUploadModal
                isOpen={showBulkUploadModal}
                onClose={() => setShowBulkUploadModal(false)}
                onUploadSuccess={handleBulkUploadSuccess}
              />
              <button
                onClick={() => setShowBulkUploadModal(true)}
                className="px-6 py-3 text-white rounded-lg transition-colors flex items-center space-x-2 flex-shrink-0"
                style={{ backgroundColor: currentTheme.color }}
              >
                <Upload className="w-5 h-5" />
                <span>Bulk Upload</span>
              </button>

            </>
          )}
          <button
            onClick={() => {
              if (activeTab === 'employees') {
                navigate('/add/employee');
              } else {
                setIsEditMode(false);
                setEditingEmployeeId(null);
                setShowAddModal(true);
              }
            }}
            className="px-6 py-3 text-white rounded-lg transition-colors flex items-center space-x-2 flex-shrink-0"
            style={{ backgroundColor: currentTheme.color }}
          >
            <UserPlus className="w-5 h-5" />
            <span>
              {activeTab === 'employees' && 'Add Employee'}
              {activeTab === 'department' && 'Add Department'}
              {activeTab === 'designation' && 'Add Designation'}
              {activeTab === 'teams' && 'Add Team'}
            </span>
          </button>
        </div>
      </div>

      {/* Loading State */}

      {loading && (
        <div className="flex items-center justify-center py-20">
          <Loader className="w-8 h-8 animate-spin" style={{ color: currentTheme.color }} />
        </div>
      )}

      {/* Content */}

      {!loading && (
        <div>
          {activeTab === 'employees' && (
            <div className={viewMode === 'grid' ? 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-6' : 'space-y-3'}>
              {employees.length > 0 ? (
                employees.map(emp => viewMode === 'grid' ? renderEmployeeCard(emp) : renderEmployeeList(emp))
              ) : (
                <div className="text-center py-20 text-gray-500 col-span-full">
                  <p>No employees found</p>
                </div>
              )}
            </div>
          )}

          {activeTab === 'department' && (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-6">
              {departments.length > 0 ? (
                departments.map(dept => renderCard(dept, 'department'))
              ) : (
                <div className="col-span-full text-center py-20 text-gray-500">
                  <p>No departments found</p>
                </div>
              )}
            </div>
          )}

          {activeTab === 'designation' && (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-6">
              {designations.length > 0 ? (
                designations.map(des => renderCard(des, 'designation'))
              ) : (
                <div className="col-span-full text-center py-20 text-gray-500">
                  <p>No designations found</p>
                </div>
              )}
            </div>
          )}

          {activeTab === 'teams' && (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-6">
              {teams.length > 0 ? (
                teams.map(team => renderCard(team, 'team'))
              ) : (
                <div className="col-span-full text-center py-20 text-gray-500">
                  <p>No teams found</p>
                </div>
              )}
            </div>
          )}
        </div>
      )}
      {/* Add Employee - Right Side Panel */}
      {showAddModal && activeTab === 'employees' && (
        <div className="fixed inset-0 bg-black/60 z-50 backdrop-blur-sm transition-all duration-300">
          {isDark && (
            <style>
              {`
                input:-webkit-autofill,
                input:-webkit-autofill:hover, 
                input:-webkit-autofill:focus, 
                input:-webkit-autofill:active {
                  -webkit-box-shadow: 0 0 0px 1000px #0f172a inset !important;
                  -webkit-text-fill-color: white !important;
                  transition: background-color 5000s ease-in-out 0s;
                }
              `}
            </style>
          )}
          <div className={`absolute right-0 top-0 h-full w-full max-w-2xl shadow-2xl overflow-hidden flex flex-col transition-all duration-300 ${isDark ? 'bg-[#1e293b]' : 'bg-white'}`}>
            {/* Header */}
            <div className={`px-6 py-4 flex items-center justify-between border-b transition-colors ${isDark ? 'bg-[#1e293b] border-white/10' : 'bg-white border-gray-100'}`}>
              <h2 className={`text-xl font-bold ${isDark ? 'text-white' : 'text-gray-800'}`}>
                {isEditMode ? 'Edit Employee' : 'Add New Employee'}
              </h2>
              <button
                onClick={() => {
                  setShowAddModal(false);
                  resetForm();
                }}
                className={`p-1 rounded-lg transition-colors ${isDark ? 'text-gray-400 hover:text-white hover:bg-white/5' : 'text-gray-500 hover:bg-gray-100'}`}
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Scrollable Content */}
            <div className={`flex-1 overflow-y-auto p-6 transition-colors ${isDark ? 'bg-[#1e293b]' : 'bg-white'}`}>
              <div className="space-y-6">
                {/* Show Employee ID as read-only when editing */}
                {isEditMode && (
                  <div className={`rounded-lg p-4 mb-4 border ${isDark ? 'bg-blue-900/20 border-blue-800/30' : 'bg-blue-50 border-blue-200'}`}>
                    <p className={`text-sm ${isDark ? 'text-blue-300' : 'text-blue-800'}`}>
                      <span className="font-semibold">Editing Employee:</span> {formData.name} (ID: {formData.employeeId})
                    </p>
                  </div>
                )}

                {/* Basic Details */}
                <div>
                  <h3 className={`text-base font-bold mb-4 ${isDark ? 'text-white' : 'text-gray-800'}`}>Basic Details</h3>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                        Employee ID <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="234564"
                        value={formData.employeeId}
                        onChange={(e) => handleInputChange('employeeId', e.target.value)}
                        onBlur={() => handleBlur('employeeId')}
                        disabled={isEditMode}
                        className={`w-full px-4 py-2.5 border rounded-lg focus:outline-none transition-all ${isDark ? 'bg-[#0f172a] border-white/10 text-white placeholder-gray-500' : 'bg-white border-gray-300 text-gray-800'} ${isEditMode ? (isDark ? 'bg-white/5 opacity-50 cursor-not-allowed' : 'bg-gray-100 cursor-not-allowed') : ''} ${errors.employeeId && touched.employeeId ? 'border-red-500' : ''}`}
                        style={isDark ? { WebkitBoxShadow: '0 0 0px 1000px #0f172a inset', WebkitTextFillColor: 'white' } : {}}
                      />
                      {errors.employeeId && touched.employeeId && (
                        <p className="text-red-500 text-xs mt-1">{errors.employeeId}</p>
                      )}
                    </div>

                    <div>
                      <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                        Employee Name <span className="text-red-500">*</span>
                      </label>
                      <div className="relative">
                        <svg className={`absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 ${isDark ? 'text-gray-500' : 'text-gray-400'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                        </svg>
                        <input
                          type="text"
                          placeholder="Veer Bhan Singh"
                          value={formData.name}
                          onChange={(e) => handleInputChange('name', e.target.value)}
                          onBlur={() => handleBlur('name')}
                          className={`w-full pl-10 pr-4 py-2.5 border rounded-lg focus:outline-none transition-all ${isDark ? 'bg-[#0f172a] border-white/10 text-white placeholder-gray-500' : 'bg-white border-gray-300 text-gray-800'} ${errors.name && touched.name ? 'border-red-500' : ''}`}
                          style={isDark ? { WebkitBoxShadow: '0 0 0px 1000px #0f172a inset', WebkitTextFillColor: 'white' } : {}}
                        />
                      </div>
                      {errors.name && touched.name && (
                        <p className="text-red-500 text-xs mt-1">{errors.name}</p>
                      )}
                    </div>

                    <div>
                      <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                        Contact number <span className="text-red-500">*</span>
                      </label>
                      <div className="relative">
                        <svg className={`absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 ${isDark ? 'text-gray-500' : 'text-gray-400'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                        </svg>
                        <input
                          type="text"
                          placeholder="9999999999"
                          value={formData.contactNumber}
                          onChange={(e) => handleInputChange('contactNumber', e.target.value.replace(/\D/g, '').slice(0, 10))}
                          onBlur={() => handleBlur('contactNumber')}
                          className={`w-full pl-10 pr-4 py-2.5 border rounded-lg focus:outline-none transition-all ${isDark ? 'bg-[#0f172a] border-white/10 text-white placeholder-gray-500' : 'bg-white border-gray-300 text-gray-800'} ${errors.contactNumber && touched.contactNumber ? 'border-red-500' : ''}`}
                          style={isDark ? { WebkitBoxShadow: '0 0 0px 1000px #0f172a inset', WebkitTextFillColor: 'white' } : {}}
                        />
                      </div>
                      {errors.contactNumber && touched.contactNumber && (
                        <p className="text-red-500 text-xs mt-1">{errors.contactNumber}</p>
                      )}
                    </div>

                    <div>
                      <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                        Email <span className="text-red-500">*</span>
                      </label>
                      <div className="relative">
                        <svg className={`absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 ${isDark ? 'text-gray-500' : 'text-gray-400'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                        </svg>
                        <input
                          type="email"
                          placeholder="awesome123@yopmail.com"
                          value={formData.email}
                          onChange={(e) => handleInputChange('email', e.target.value)}
                          onBlur={() => handleBlur('email')}
                          className={`w-full pl-10 pr-4 py-2.5 border rounded-lg focus:outline-none transition-all ${isDark ? 'bg-[#0f172a] border-white/10 text-white placeholder-gray-500' : 'bg-white border-gray-300 text-gray-800'} ${errors.email && touched.email ? 'border-red-500' : ''}`}
                          style={isDark ? { WebkitBoxShadow: '0 0 0px 1000px #0f172a inset', WebkitTextFillColor: 'white' } : {}}
                        />
                      </div>
                      {errors.email && touched.email && (
                        <p className="text-red-500 text-xs mt-1">{errors.email}</p>
                      )}
                    </div>

                    <div>
                      <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Gender</label>
                      <div className="flex gap-4 pt-2">
                        <label className={`flex items-center space-x-2 cursor-pointer ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>
                          <input
                            type="radio"
                            name="gender"
                            value="MALE"
                            checked={formData.gender === 'MALE'}
                            onChange={(e) => handleInputChange('gender', e.target.value)}
                            className="text-teal-600 focus:ring-teal-500"
                          />
                          <span className="text-sm">Male</span>
                        </label>
                        <label className={`flex items-center space-x-2 cursor-pointer ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>
                          <input
                            type="radio"
                            name="gender"
                            value="FEMALE"
                            checked={formData.gender === 'FEMALE'}
                            onChange={(e) => handleInputChange('gender', e.target.value)}
                            className="text-teal-600 focus:ring-teal-500"
                          />
                          <span className="text-sm">Female</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Address - Same fields as before */}
                <div>
                  <h3 className={`text-base font-bold mb-4 ${isDark ? 'text-white' : 'text-gray-800'}`}>Address</h3>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                        Address (street and locality) <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="E-23"
                        value={formData.addressStreet}
                        onChange={(e) => handleInputChange('addressStreet', e.target.value)}
                        onBlur={() => handleBlur('addressStreet')}
                        className={`w-full px-4 py-2.5 border rounded-lg focus:outline-none transition-all ${isDark ? 'bg-[#0f172a] border-white/10 text-white placeholder-gray-500' : 'bg-white border-gray-300 text-gray-800'} ${errors.addressStreet && touched.addressStreet ? 'border-red-500' : ''}`}
                        style={isDark ? { WebkitBoxShadow: '0 0 0px 1000px #0f172a inset', WebkitTextFillColor: 'white' } : {}}
                      />
                      {errors.addressStreet && touched.addressStreet && (
                        <p className="text-red-500 text-xs mt-1">{errors.addressStreet}</p>
                      )}
                    </div>

                    <div>
                      <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Landmark</label>
                      <input
                        type="text"
                        placeholder="Police chawki"
                        value={formData.landmark}
                        onChange={(e) => handleInputChange('landmark', e.target.value)}
                        className={`w-full px-4 py-2.5 border rounded-lg focus:outline-none transition-all ${isDark ? 'bg-[#0f172a] border-white/10 text-white placeholder-gray-500' : 'bg-white border-gray-300 text-gray-800'}`}
                        style={isDark ? { WebkitBoxShadow: '0 0 0px 1000px #0f172a inset', WebkitTextFillColor: 'white' } : {}}
                      />
                    </div>

                    <div>
                      <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                        Area pincode <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="201301"
                        value={formData.pincode}
                        onChange={(e) => handleInputChange('pincode', e.target.value.replace(/\D/g, '').slice(0, 6))}
                        onBlur={() => handleBlur('pincode')}
                        className={`w-full px-4 py-2.5 border rounded-lg focus:outline-none transition-all ${isDark ? 'bg-[#0f172a] border-white/10 text-white placeholder-gray-500' : 'bg-white border-gray-300 text-gray-800'} ${errors.pincode && touched.pincode ? 'border-red-500' : ''}`}
                        style={isDark ? { WebkitBoxShadow: '0 0 0px 1000px #0f172a inset', WebkitTextFillColor: 'white' } : {}}
                      />
                      {errors.pincode && touched.pincode && (
                        <p className="text-red-500 text-xs mt-1">{errors.pincode}</p>
                      )}
                    </div>

                    <div>
                      <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                        City <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="Noida"
                        value={formData.city}
                        onChange={(e) => handleInputChange('city', e.target.value)}
                        onBlur={() => handleBlur('city')}
                        className={`w-full px-4 py-2.5 border rounded-lg focus:outline-none transition-all ${isDark ? 'bg-[#0f172a] border-white/10 text-white placeholder-gray-500' : 'bg-white border-gray-300 text-gray-800'} ${errors.city && touched.city ? 'border-red-500' : ''}`}
                        style={isDark ? { WebkitBoxShadow: '0 0 0px 1000px #0f172a inset', WebkitTextFillColor: 'white' } : {}}
                      />
                      {errors.city && touched.city && (
                        <p className="text-red-500 text-xs mt-1">{errors.city}</p>
                      )}
                    </div>

                    <div>
                      <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                        District <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="Gautam Buddha Nagar"
                        value={formData.district}
                        onChange={(e) => handleInputChange('district', e.target.value)}
                        onBlur={() => handleBlur('district')}
                        className={`w-full px-4 py-2.5 border rounded-lg focus:outline-none transition-all ${isDark ? 'bg-[#0f172a] border-white/10 text-white placeholder-gray-500' : 'bg-white border-gray-300 text-gray-800'} ${errors.district && touched.district ? 'border-red-500' : ''}`}
                        style={isDark ? { WebkitBoxShadow: '0 0 0px 1000px #0f172a inset', WebkitTextFillColor: 'white' } : {}}
                      />
                      {errors.district && touched.district && (
                        <p className="text-red-500 text-xs mt-1">{errors.district}</p>
                      )}
                    </div>

                    <div>
                      <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                        State <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="Uttar Pradesh"
                        value={formData.state}
                        onChange={(e) => handleInputChange('state', e.target.value)}
                        onBlur={() => handleBlur('state')}
                        className={`w-full px-4 py-2.5 border rounded-lg focus:outline-none transition-all ${isDark ? 'bg-[#0f172a] border-white/10 text-white placeholder-gray-500' : 'bg-white border-gray-300 text-gray-800'} ${errors.state && touched.state ? 'border-red-500' : ''}`}
                        style={isDark ? { WebkitBoxShadow: '0 0 0px 1000px #0f172a inset', WebkitTextFillColor: 'white' } : {}}
                      />
                      {errors.state && touched.state && (
                        <p className="text-red-500 text-xs mt-1">{errors.state}</p>
                      )}
                    </div>
                  </div>
                </div>

                {/* Employment details */}
                <div>
                  <h3 className={`text-base font-bold mb-4 ${isDark ? 'text-white' : 'text-gray-800'}`}>Employment details</h3>
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                    <div>
                      <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                        Department <span className="text-red-500">*</span>
                      </label>
                      <select
                        value={formData.departmentId}
                        onChange={(e) => handleInputChange('departmentId', e.target.value)}
                        onBlur={() => handleBlur('departmentId')}
                        className={`w-full px-4 py-2.5 border rounded-lg focus:outline-none transition-all appearance-none ${isDark ? 'bg-[#0f172a] border-white/10 text-white' : 'bg-white border-gray-300 text-gray-800'} ${errors.departmentId && touched.departmentId ? 'border-red-500' : ''}`}
                      >
                        <option value="">Select Department</option>
                        {departments.map(dept => (
                          <option key={dept.id} value={dept.id} className={isDark ? 'bg-[#1e293b]' : ''}>{dept.name}</option>
                        ))}
                      </select>
                      {errors.departmentId && touched.departmentId && (
                        <p className="text-red-500 text-xs mt-1">{errors.departmentId}</p>
                      )}
                    </div>

                    <div>
                      <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                        Team <span className="text-red-500">*</span>
                      </label>
                      <select
                        value={formData.team}
                        onChange={(e) => handleInputChange('team', e.target.value)}
                        onBlur={() => handleBlur('team')}
                        className={`w-full px-4 py-2.5 border rounded-lg focus:outline-none transition-all appearance-none ${isDark ? 'bg-[#0f172a] border-white/10 text-white' : 'bg-white border-gray-300 text-gray-800'} ${errors.team && touched.team ? 'border-red-500' : ''}`}
                      >
                        <option value="">Select Team</option>
                        {teams.map(team => (
                          <option key={team.id} value={team.id} className={isDark ? 'bg-[#1e293b]' : ''}>{team.name}</option>
                        ))}
                      </select>
                      {errors.team && touched.team && (
                        <p className="text-red-500 text-xs mt-1">{errors.team}</p>
                      )}
                    </div>

                    <div>
                      <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                        Designation <span className="text-red-500">*</span>
                      </label>
                      <select
                        value={formData.designationId}
                        onChange={(e) => handleInputChange('designationId', e.target.value)}
                        onBlur={() => handleBlur('designationId')}
                        className={`w-full px-4 py-2.5 border rounded-lg focus:outline-none transition-all appearance-none ${isDark ? 'bg-[#0f172a] border-white/10 text-white' : 'bg-white border-gray-300 text-gray-800'} ${errors.designationId && touched.designationId ? 'border-red-500' : ''}`}
                      >
                        <option value="">Select Designation</option>
                        {designations.map(designation => (
                          <option key={designation.id} value={designation.id} className={isDark ? 'bg-[#1e293b]' : ''}>{designation.name}</option>
                        ))}
                      </select>
                      {errors.designationId && touched.designationId && (
                        <p className="text-red-500 text-xs mt-1">{errors.designationId}</p>
                      )}
                    </div>

                    <div>
                      <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                        Employee Code <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="Emp-123911"
                        value={formData.employeeCode}
                        onChange={(e) => handleInputChange('employeeCode', e.target.value)}
                        onBlur={() => handleBlur('employeeCode')}
                        className={`w-full px-4 py-2.5 border rounded-lg focus:outline-none transition-all ${isDark ? 'bg-[#0f172a] border-white/10 text-white placeholder-gray-500' : 'bg-white border-gray-300 text-gray-800'} ${errors.employeeCode && touched.employeeCode ? 'border-red-500' : ''}`}
                        style={isDark ? { WebkitBoxShadow: '0 0 0px 1000px #0f172a inset', WebkitTextFillColor: 'white' } : {}}
                      />
                      {errors.employeeCode && touched.employeeCode && (
                        <p className="text-red-500 text-xs mt-1">{errors.employeeCode}</p>
                      )}
                    </div>

                    <div>
                      <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                        Agent ID <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="423"
                        value={formData.agentId}
                        onChange={(e) => handleInputChange('agentId', e.target.value)}
                        onBlur={() => handleBlur('agentId')}
                        className={`w-full px-4 py-2.5 border rounded-lg focus:outline-none transition-all ${isDark ? 'bg-[#0f172a] border-white/10 text-white placeholder-gray-500' : 'bg-white border-gray-300 text-gray-800'} ${errors.agentId && touched.agentId ? 'border-red-500' : ''}`}
                        style={isDark ? { WebkitBoxShadow: '0 0 0px 1000px #0f172a inset', WebkitTextFillColor: 'white' } : {}}
                      />
                      {errors.agentId && touched.agentId && (
                        <p className="text-red-500 text-xs mt-1">{errors.agentId}</p>
                      )}
                    </div>
                    <div>
                      <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                        Password <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="password"
                        placeholder="••••••••"
                        value={formData.password}
                        onChange={(e) => handleInputChange('password', e.target.value)}
                        onBlur={() => handleBlur('password')}
                        className={`w-full px-4 py-2.5 border rounded-lg focus:outline-none transition-all ${isDark ? 'bg-[#0f172a] border-white/10 text-white placeholder-gray-500' : 'bg-white border-gray-300 text-gray-800'} ${errors.password && touched.password ? 'border-red-500' : ''}`}
                        style={isDark ? { WebkitBoxShadow: '0 0 0px 1000px #0f172a inset', WebkitTextFillColor: 'white' } : {}}
                      />
                      {errors.password && touched.password && (
                        <p className="text-red-500 text-xs mt-1">{errors.password}</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Fixed Footer */}
            <div className={`px-6 py-4 border-t flex justify-between items-center transition-colors ${isDark ? 'bg-[#1e293b] border-white/10' : 'bg-white border-gray-100'}`}>
              <button
                onClick={() => {
                  setShowAddModal(false);
                  resetForm();
                }}
                className={`px-6 py-2.5 border-2 rounded-lg transition-colors font-medium ${isDark ? 'border-white/10 text-gray-300 hover:bg-white/5' : 'border-gray-300 text-gray-700 hover:bg-gray-50'}`}
              >
                Cancel
              </button>
              <button
                onClick={handleSaveEmployee}
                disabled={loading}
                className="px-10 py-2.5 text-white rounded-lg font-bold shadow-lg hover:opacity-90 transition-all disabled:opacity-50 flex items-center gap-2"
                style={{ backgroundColor: currentTheme.color }}
              >
                {loading && <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>}
                <span>{isEditMode ? 'Update Employee' : 'Save Employee'}</span>
              </button>
            </div>
          </div>
        </div>
      )}


      {/* end of model  */}



      {/* Other Modals (Department, Designation, Team) - Keep as centered popups */}
      {showAddModal && activeTab !== 'employees' && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          {/* Add Department Modal */}
          {activeTab === 'department' && (
            <div className={`rounded-2xl shadow-2xl w-full max-w-md overflow-hidden transition-all duration-300 ${isDark ? 'bg-[#1e293b] border border-white/10' : 'bg-white'}`}>
              <div className="px-6 py-4 flex items-center justify-between" style={{ backgroundColor: isDark ? `${currentTheme.color}20` : `${currentTheme.color}33` }}>
                <h2 className={`text-xl font-bold ${isDark ? 'text-white' : 'text-gray-800'}`}>{isEditMode ? 'Edit Department' : 'Add New Department'}</h2>
                <button
                  onClick={() => {
                    setShowAddModal(false);
                    setIsEditMode(false);
                    setEditingEmployeeId(null);
                    setDepartmentFormData({ name: '', description: '' });
                  }}
                  className={`p-1 rounded-lg transition-colors ${isDark ? 'hover:bg-white/10 text-gray-400 hover:text-white' : 'hover:bg-black/5 text-gray-500 hover:text-gray-800'}`}
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>

              <div className="p-6 space-y-4">
                <div>
                  <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Department name</label>
                  <input
                    type="text"
                    placeholder="Outbound sales"
                    value={departmentFormData.name}
                    onChange={(e) => setDepartmentFormData({ ...departmentFormData, name: e.target.value })}
                    className={`w-full px-4 py-2.5 border rounded-lg focus:outline-none transition-all ${isDark ? 'bg-[#0f172a] border-white/10 text-white placeholder-gray-500 focus:border-white/30' : 'bg-white border-gray-300 text-gray-800 focus:border-teal-500'}`}
                  />
                </div>

                <div>
                  <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Description</label>
                  <textarea
                    rows="4"
                    placeholder="A proactive selling approach where a sales representative initiates contact with potential customers (leads) to introduce a product or service"
                    value={departmentFormData.description}
                    onChange={(e) => setDepartmentFormData({ ...departmentFormData, description: e.target.value })}
                    className={`w-full px-4 py-2.5 border rounded-lg focus:outline-none transition-all resize-none ${isDark ? 'bg-[#0f172a] border-white/10 text-white placeholder-gray-500 focus:border-white/30' : 'bg-white border-gray-300 text-gray-800 focus:border-teal-500'}`}
                  />
                </div>

                <button
                  onClick={handleAddDepartment}
                  disabled={loading}
                  className="w-full py-2.5 text-white rounded-lg transition-colors font-bold shadow-lg hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center space-x-2"
                  style={{ backgroundColor: currentTheme.color }}
                >
                  {loading && <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>}
                  <span>{isEditMode ? 'Update Department' : 'Save Department'}</span>
                </button>
              </div>
            </div>
          )}

          {/* Add Designation Modal */}
          {activeTab === 'designation' && (
            <div className={`rounded-2xl shadow-2xl w-full max-w-md overflow-hidden transition-all duration-300 ${isDark ? 'bg-[#1e293b] border border-white/10' : 'bg-white'}`}>
              <div className="px-6 py-4 flex items-center justify-between" style={{ backgroundColor: isDark ? `${currentTheme.color}20` : `${currentTheme.color}33` }}>
                <h2 className={`text-xl font-bold ${isDark ? 'text-white' : 'text-gray-800'}`}>{isEditMode ? 'Edit Designation' : 'Add New Designation'}</h2>
                <button
                  onClick={() => {
                    setShowAddModal(false);
                    setIsEditMode(false);
                    setEditingEmployeeId(null);
                    setDesignationFormData({ name: '', description: '' });
                  }}
                  className={`p-1 rounded-lg transition-colors ${isDark ? 'hover:bg-white/10 text-gray-400 hover:text-white' : 'hover:bg-black/5 text-gray-500 hover:text-gray-800'}`}
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>

              <div className="p-6 space-y-4">
                <div>
                  <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Designation name</label>
                  <input
                    type="text"
                    placeholder="Senior Sales Representative"
                    value={designationFormData.name}
                    onChange={(e) => setDesignationFormData({ ...designationFormData, name: e.target.value })}
                    className={`w-full px-4 py-2.5 border rounded-lg focus:outline-none transition-all ${isDark ? 'bg-[#0f172a] border-white/10 text-white placeholder-gray-500 focus:border-white/30' : 'bg-white border-gray-300 text-gray-800 focus:border-teal-500'}`}
                  />
                </div>

                <div>
                  <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Description</label>
                  <textarea
                    rows="4"
                    placeholder="Enter designation details..."
                    value={designationFormData.description}
                    onChange={(e) => setDesignationFormData({ ...designationFormData, description: e.target.value })}
                    className={`w-full px-4 py-2.5 border rounded-lg focus:outline-none transition-all resize-none ${isDark ? 'bg-[#0f172a] border-white/10 text-white placeholder-gray-500 focus:border-white/30' : 'bg-white border-gray-300 text-gray-800 focus:border-teal-500'}`}
                  />
                </div>

                <button
                  onClick={handleAddDesignation}
                  disabled={loading}
                  className="w-full py-2.5 text-white rounded-lg transition-colors font-bold shadow-lg hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center space-x-2"
                  style={{ backgroundColor: currentTheme.color }}
                >
                  {loading && <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>}
                  <span>{isEditMode ? 'Update Designation' : 'Save Designation'}</span>
                </button>
              </div>
            </div>
          )}

          {/* Add Team Modal */}
          {activeTab === 'teams' && (
            <div className={`rounded-2xl shadow-2xl w-full max-w-md overflow-hidden transition-all duration-300 ${isDark ? 'bg-[#1e293b] border border-white/10' : 'bg-white'}`}>
              <div className="px-6 py-4 flex items-center justify-between" style={{ backgroundColor: isDark ? `${currentTheme.color}20` : `${currentTheme.color}33` }}>
                <h2 className={`text-xl font-bold ${isDark ? 'text-white' : 'text-gray-800'}`}>{isEditMode ? 'Edit Team' : 'Add New Team'}</h2>
                <button
                  onClick={() => {
                    setShowAddModal(false);
                    setIsEditMode(false);
                    setEditingEmployeeId(null);
                    setTeamFormData({ name: '', description: '' });
                  }}
                  className={`p-1 rounded-lg transition-colors ${isDark ? 'hover:bg-white/10 text-gray-400 hover:text-white' : 'hover:bg-black/5 text-gray-500 hover:text-gray-800'}`}
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>

              <div className="p-6 space-y-4">
                <div>
                  <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Team name</label>
                  <input
                    type="text"
                    placeholder="Alpha Team"
                    value={teamFormData.name}
                    onChange={(e) => setTeamFormData({ ...teamFormData, name: e.target.value })}
                    className={`w-full px-4 py-2.5 border rounded-lg focus:outline-none transition-all ${isDark ? 'bg-[#0f172a] border-white/10 text-white placeholder-gray-500 focus:border-white/30' : 'bg-white border-gray-300 text-gray-800 focus:border-teal-500'}`}
                  />
                </div>

                <div>
                  <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Description</label>
                  <textarea
                    rows="4"
                    placeholder="Enter team details..."
                    value={teamFormData.description}
                    onChange={(e) => setTeamFormData({ ...teamFormData, description: e.target.value })}
                    className={`w-full px-4 py-2.5 border rounded-lg focus:outline-none transition-all resize-none ${isDark ? 'bg-[#0f172a] border-white/10 text-white placeholder-gray-500 focus:border-white/30' : 'bg-white border-gray-300 text-gray-800 focus:border-teal-500'}`}
                  />
                </div>

                <div>
                  <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Status</label>
                  <div className="flex items-center space-x-3 pt-1">
                    <Toggle
                      checked={teamFormData.isActive !== false}
                      onChange={(checked) => setTeamFormData({ ...teamFormData, isActive: checked })}
                      color={currentTheme.color}
                    />
                    <span className={`text-sm font-medium ${teamFormData.isActive !== false ? 'text-emerald-600' : 'text-gray-500'}`}>
                      {teamFormData.isActive !== false ? 'Active' : 'Inactive'}
                    </span>
                  </div>
                </div>

                <button
                  onClick={handleAddTeam}
                  disabled={loading}
                  className="w-full py-2.5 text-white rounded-lg transition-colors font-bold shadow-lg hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center space-x-2"
                  style={{ backgroundColor: currentTheme.color }}
                >
                  {loading && <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>}
                  <span>{isEditMode ? 'Update Team' : 'Save Team'}</span>
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

function Toggle({ checked, onChange, color }) {
  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        onChange(!checked);
      }}
      className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors focus:outline-none ${
        checked ? '' : 'bg-gray-300'
      }`}
      style={{ backgroundColor: checked ? color : '#D1D5DB' }}
    >
      <span
        className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
          checked ? 'translate-x-4' : 'translate-x-0.5'
        }`}
      />
    </button>
  );
}

export default EmployeeManagement;